export default __webpack_public_path__ + "static/media/location-pin-icon.649aefe7.svg";